export default {
  'menu.servers': 'Управление серверами',
  'menu.user.center': 'Аккаунт',
  'menu.dashboard': 'Панель управления',
  'menu.devices': 'Устройства',
  'menu.addressBook': 'Адресные книги',
  'menu.addressBook.personal': 'Личные',
  'menu.addressBook.shared': 'Общие',
  'menu.users': 'Пользователи',
  'menu.audits': 'Журналы аудита',
  'menu.audits.conn': 'Подключения',
  'menu.audits.file': 'Передача файлов',
  'menu.audits.alarm': 'Оповещения',
  'menu.audits.console': 'Консоль',
  'menu.login': 'Вход',
  'menu.roles': 'Роли',
  'menu.strategies': 'Стратегии',
  'menu.groups': 'Группы',
  'menu.groups.user': 'Группы пользователей',
  'menu.groups.device': 'Группы устройств',
  'menu.settings': 'Настройки',
  'menu.settings.general': 'Общие настройки',
  'menu.settings.smtp': 'Настройки SMTP',
  'menu.settings.oidcProviders': 'Провайдеры OIDC',
  'menu.settings.ldap': 'Настройки LDAP',
  'menu.customClients': 'Пользовательские клиенты',
  'menu.list.audit-list': 'Список аудита',
  'menu.list.audit-list.File': 'Передача файлов',
  'menu.list.audit-list.Connection': 'Подключения',
  'menu.list.audit-list.Alarm': 'Оповещения',
};
